





































import { defineComponent, ref } from '@vue/composition-api'
import { PropType } from 'vue';
import PageBuilderComponent from '~/mixins/solepro/PageBuilderComponent.vue';
import { RowType } from '~/types/solepro/PageBuilder';
import VideoBackground from '~/mixins/solepro/VideoBackground.vue';
import { GenericObjectType } from '~/utils/types';
import { trackPageBuilderButton } from '~/helpers/trackings/24orepro/components';
import BrightcoveVideo from '../BrightcoveVideo.vue';

export default defineComponent({
    name: "Events",
    mixins: [PageBuilderComponent, VideoBackground],
    props: {
        node: {
            type: Object as PropType<RowType>,
            required: true
        },
        customProps: {
            type: Object as PropType<GenericObjectType>,
            default: () => { return {} }
        }
    },
    components: {
        PageBuilderComponent,
        BrightcoveVideo
    },
    setup(props) {
        //@TODO brightcove poster
        const content = props.node;
        const videoDiv = ref(null)
        const hasParallax = content.enableParallax == '1' && content.backgroundImages != "" && content.backgroundImages != "{}";
        const isLink = !!content.soleProfessionistiUrl;
        const WrapperComponent = hasParallax ? () => import('~/components/Parallax.vue') : 'div'
        const isTrack = !!content.soleProfessionistiTrack;
        const hasIframe = content.videoSrc && !content.videoSrc.split('?')[0].endsWith('.mp4') && !content.videoSrc.includes('brightcove')
        //@ts-ignore
        const textElement = content.children.find(el => el.contentType == 'text').DOMContent.innerHTML;
        const callbackFn = () => {
            if (content.target == '_blank') {
                window.open(content.soleProfessionistiUrl, content.target).focus();
            } else {
                location.href = `${content.soleProfessionistiUrl}`;
            }
        };
        const trackFunction = (e, callbackFn?: Function) => {
            e.preventDefault();
            trackPageBuilderButton(content.soleProfessionistiTrack, content.soleProfessionistiUrl, content.target ?? null, callbackFn);
        }
        const trackRow = (e) => isTrack && isLink ? trackFunction(e, callbackFn) : callbackFn()
        const isHovered = ref<Boolean>(true) /** workaround to avoid browser play blocking before interaction */
        return {
            trackRow,
            WrapperComponent,
            content,
            hasIframe,
            hasParallax,
            isContained: content.appearance == 'contained',
            isFullWidth: content.appearance == 'full-width',
            isHovered,
            textElement,
            videoDiv
        }
    },
    mounted() {
        const $th = this;
        if (window.innerWidth < 1024) return;
        setTimeout(() => {
            $th.loadVideo()
        }, 0)
    },
    methods: {
        loadVideo() {
            // @ts-ignore
            const video = this.$refs?.videoDiv.querySelector('video') as HTMLVideoElement;
            if (video && !this.content.videoSrc.includes('brightcove')) {
                const source = video.children[0] as HTMLSourceElement;
                if (source && source.tagName == 'SOURCE') {
                    source.src = source.getAttribute('data-src').replace('mp4:', '');
                    video.load();
                }
            }
            setTimeout(() => {
                this.isHovered = false
            }, 100) /** workaround to avoid browser play blocking before interaction */
        },
        showBg() {
            this.isHovered = true
            setTimeout(()=>{
                const video = this.$el.querySelector('video');
                if (video) {
                    video.play();
                }

            },100)
        },
        hideBg() {
            this.isHovered = false
            const video = this.$el.querySelector('video');
            if (video) {
                video.pause();
            }
        },
        manageUrl() {
            const url = this.content.soleProfessionistiUrl
            const target = this.content.soleProfessionistiNewTab == '1' ? '_blank' : null;
            if (!url) return;
            if (target == '_blank') {
                window.open(url, target).focus();
            } else {
                location.href = url;
            }
        }
    }
})
